
Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.Stop = Greenmile.RouteDetail.Stop || {};

Greenmile.RouteDetail.Stop.Menu = (function () {

    function Menu() {

        Greenmile.Grid.Menu.apply(this, arguments);

        var _routeId = null;

        this.setRouteId = function (routeId) {
            _routeId = routeId;
        };

        this.getItemsToMenu = function (stop) {

            var items                = [],
                goToMarkLocation     = null,
                goToEditLocation     = null,
                gridMenu             = null,
                goToLocationMenuIcon = 'listStopsDisabled',
                goToMarkIcon         = 'goToMarkDisabled',
                model;

            if (stop) {

                gridMenu = this.gridMenu;
                model = stop.attributes.stop;
                const hasValidLocation = model.location && model.location.latitude && model.location.longitude;
                const hasValidLatLong = model.longitude && model.latitude;
                const permissions = Monet.Session.Security.permissions;
                const hasEditLocationPermission = permissions.some(permission => permission.key === "LOCATION_UPDATE");

                if (hasValidLocation || hasValidLatLong) {
                  goToMarkIcon = 'goToMark';
                }
                if (model.location) {
                  goToLocationMenuIcon = 'listStops';
                }
                goToMarkLocation = {
                    id: 1,
                    description: Monet.I18n.getResourcesByKey('Greenmile.RouteDetail.GoToMarkLocation'),
                    icon: goToMarkIcon,
                    customClassname: goToMarkIcon.indexOf('Disabled') !== -1 ? 'disabled' : '',
                    action: function () {

                        const locationLat = model.location ? model.location.latitude : null;
                        const locationLng = model.location ? model.location.longitude : null;

                        if ( (model.latitude && model.longitude) || (locationLat && locationLng)) {
                            var map = new Greenmile.RouteDetail.Map(_routeId);
                            map.focusOnTheStop(model);
                            gridMenu.removeAllMenus();
                        }

                    }
                };

                goToEditLocation = {
                    id: 2,
                    description: Monet.I18n.getResourcesByKey('Greenmile.RouteDetail.GoToEditLocation'),
                    icon: goToLocationMenuIcon,
                    customClassname: goToLocationMenuIcon.indexOf('Disabled') !== -1 ? 'disabled' : '',
                    action: function () {

                        if (stop.attributes.stop.location) {
                            var tabs = $('#tabs > div').tabs();
                            var locationTabIndex = null;
                            for (var i in tabs) {
                                if (tabs[i].id === 'Location') {
                                    locationTabIndex = i;
                                    break;
                                }
                            }

                            window.location = "#/Location/edit/" + stop.attributes.stop.location.id;

                            if (locationTabIndex) {
                                $('#tabs').tabs({active: locationTabIndex});
                            }
                        }
                    }
                };

                items.push(goToMarkLocation);
                hasEditLocationPermission && items.push(goToEditLocation);
            }

            return items;
        };
    }

    return Menu;

}());
